import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "deleted-orders-report" };
const _hoisted_2 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "row mb-30 g-4" };
const _hoisted_5 = { class: "col-md-3" };
const _hoisted_6 = { class: "kpi-card border-danger-subtle bg-danger-subtle text-danger p-20 rounded shadow-sm" };
const _hoisted_7 = { class: "fw-black mb-0" };
const _hoisted_8 = { class: "col-md-9" };
const _hoisted_9 = { class: "card border-0 shadow-sm p-20 h-100" };
const _hoisted_10 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_11 = { class: "reason-text" };
const _hoisted_12 = { class: "reason-count" };
const _hoisted_13 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_14 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_15 = { class: "table-responsive" };
const _hoisted_16 = { class: "table table-hover align-middle table-sm" };
const _hoisted_17 = { class: "fw-bold text-dark" };
const _hoisted_18 = { class: "small" };
const _hoisted_19 = { class: "small text-danger" };
const _hoisted_20 = { class: "text-end fw-medium" };
const _hoisted_21 = { class: "badge bg-light text-dark fw-normal border px-2 py-1" };
const _hoisted_22 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("div", {
                        class: "spinner-border text-danger",
                        role: "status"
                    }, null, -1),
                    _createElementVNode("p", { class: "text-muted mt-2" }, "Chargement des rapports de suppression...", -1)
                ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "small fw-bold text-uppercase mb-1 opacity-75" }, "Commandes Annulées", -1)),
                            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.reportData.total), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "fw-bold mb-15 text-uppercase small text-muted" }, "Principales raisons d'annulation", -1)),
                            _createElementVNode("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData.reasons, (r) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: r.reason,
                                        class: "reason-badge"
                                    }, [
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(r.reason), 1),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(r.count), 1)
                                    ]));
                                }), 128)),
                                (_ctx.reportData.reasons.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Aucune raison enregistrée."))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "fw-bold mb-20 text-uppercase small text-muted" }, "Historique", -1)),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("table", _hoisted_16, [
                            _cache[4] || (_cache[4] = _createElementVNode("thead", { class: "bg-light" }, [
                                _createElementVNode("tr", { class: "small text-muted" }, [
                                    _createElementVNode("th", null, "Reference"),
                                    _createElementVNode("th", null, "Créée le"),
                                    _createElementVNode("th", null, "Annulée le"),
                                    _createElementVNode("th", { class: "text-end" }, "Montant perdu"),
                                    _createElementVNode("th", null, "Raison / Justification")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData.orders, (o) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: o.id
                                    }, [
                                        _createElementVNode("td", _hoisted_17, _toDisplayString(o.reference), 1),
                                        _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatDate(o.date)), 1),
                                        _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.formatDate(o.deletedAt)), 1),
                                        _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.formatCHF(o.amount)), 1),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(o.reason), 1)
                                        ])
                                    ]));
                                }), 128)),
                                (_ctx.reportData.orders.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[3] || (_cache[3] = [
                                            _createElementVNode("td", {
                                                colspan: "5",
                                                class: "text-center py-5 text-muted small"
                                            }, [
                                                _createElementVNode("i", { class: "ph ph-shield-check fs-40 mb-2 d-block" }),
                                                _createTextVNode(" Aucune commande supprimée sur cette période. ")
                                            ], -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ]))
    ]));
}
